<template>
  <div class="mob-plan-compare-area">
    <h4 class="tit-h5 mb-7">{{ t('ss_compare_plans') }}</h4>

    <div class="under-linetab-wrap mb-6">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        type="button"
        class="tab-item"
        :class="{ on: activeIndex === index }"
        @click="selectTab(index)"
      >
        {{ tab }}
      </button>
    </div>

    <div class="compare-btn-area">
      <div class="plan-ch-btn-wrap mb-4" :class="{ on: activeIndex === 0 }">
        <p>{{ t('ss_plan_desc_intro') }}</p>
        <button
          type="button"
          class="l-btn"
          :class="{ 'gray-btn': !isChangePlan('FREE'), 'btn-primary': isChangePlan('FREE') }"
          :disabled="getPlanDisabledState('FREE')"
          @click="handlePlanClick('FREE')"
        >
          {{ getPlanButtonText('FREE') }}
        </button>
      </div>

      <div class="plan-ch-btn-wrap mb-4" :class="{ on: activeIndex === 1 }">
        <p>{{ t('ss_plan_desc_starter') }}</p>
        <button
          type="button"
          class="l-btn"
          :class="{ 'gray-btn': !isChangePlan('STARTER'), 'btn-primary': isChangePlan('STARTER') }"
          :disabled="getPlanDisabledState('STARTER')"
          @click="handlePlanClick('STARTER')"
        >
          {{ getPlanButtonText('STARTER') }}
        </button>
      </div>

      <div class="plan-ch-btn-wrap mb-4" :class="{ on: activeIndex === 2 }">
        <p>{{ t('ss_plan_desc_pro') }}</p>
        <button
          type="button"
          class="l-btn"
          :class="{ 'gray-btn': !isChangePlan('PRO'), 'btn-primary': isChangePlan('PRO') }"
          :disabled="getPlanDisabledState('PRO')"
          @click="handlePlanClick('PRO')"
        >
          {{ getPlanButtonText('PRO') }}
        </button>
      </div>

      <div class="plan-ch-btn-wrap mb-4" :class="{ on: activeIndex === 3 }">
        <p>{{ t('ss_enterprise_desc') }}</p>
        <button type="button" class="l-btn gray-btn" @click="handlePlanClick('ENTERPRISE')">
          {{ getPlanButtonText('ENTERPRISE') }}
        </button>
      </div>
    </div>

    <div class="mob-compare-tb" :class="{ on: activeIndex === 0 }">
      <dl>
        <dt>{{ t('ss_usage_fee') }}</dt>
        <dd>{{ t('ss_price_free') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_credits') }}</dt>
        <dd>1,000{{ t('ss_credits') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('credit_purchase_discount_rate') }}</dt>
        <dd>{{ t('label_none') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_small_conversation') }}</dt>
        <dd>{{ t('ss_time_32min') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('label_conference') }}</dt>
        <dd>{{ t('ss_time_32min') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_label_convention') }}</dt>
        <dd>{{ t('ss_time_32min') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_simultaneous_session') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_refill_supported') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_full_service') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_support_channels') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_consulting_short') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_onsite') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
    </div>

    <div class="mob-compare-tb" :class="{ on: activeIndex === 1 }">
      <dl>
        <dt>{{ t('ss_usage_fee') }}</dt>
        <dd>
          {{
            formatCurrency(
              planPrices['STARTER']?.[subscriptionStore.currency].pricePerMonth,
              subscriptionStore.currency
            )
          }}
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_credits') }}</dt>
        <dd>15,000 {{ t('ss_credits') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('credit_purchase_discount_rate') }}</dt>
        <dd>25%</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_small_conversation') }}</dt>
        <dd>{{ t('ss_time_8h') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('label_conference') }}</dt>
        <dd>{{ t('ss_time_8h') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_label_convention') }}</dt>
        <dd>{{ t('ss_time_8h') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_simultaneous_session') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_refill_supported') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_full_service') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_support_channels') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_consulting_short') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_onsite') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
    </div>

    <div class="mob-compare-tb" :class="{ on: activeIndex === 2 }">
      <dl>
        <dt>{{ t('ss_usage_fee') }}</dt>
        <dd>
          {{
            formatCurrency(planPrices['PRO']?.[subscriptionStore.currency].pricePerMonth, subscriptionStore.currency)
          }}
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_credits') }}</dt>
        <dd>86,900 {{ t('ss_credits') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('credit_purchase_discount_rate') }}</dt>
        <dd>50%</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_small_conversation') }}</dt>
        <dd>{{ t('ss_time_46h') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('label_conference') }}</dt>
        <dd>{{ t('ss_time_46h') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_label_convention') }}</dt>
        <dd>{{ t('ss_time_46h') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_simultaneous_session') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_refill_supported') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_full_service') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_support_channels') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_consulting_short') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_onsite') }}</dt>
        <dd>
          <CloseIcon class="n-icon" />
        </dd>
      </dl>
    </div>

    <div class="mob-compare-tb" :class="{ on: activeIndex === 3 }">
      <dl>
        <dt>{{ t('ss_usage_fee') }}</dt>
        <dd>{{ t('ss_contact_short') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_credits') }}</dt>
        <dd>{{ t('ss_contact_short') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('credit_purchase_discount_rate') }}</dt>
        <dd>{{ t('inquiry') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_small_conversation') }}</dt>
        <dd>{{ t('ss_contact_short') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('label_conference') }}</dt>
        <dd>{{ t('ss_contact_short') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_label_convention') }}</dt>
        <dd>{{ t('ss_contact_short') }}</dd>
      </dl>
      <dl>
        <dt>{{ t('ss_simultaneous_session') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_refill_supported') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_full_service') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_support_channels') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_consulting_short') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
      <dl>
        <dt>{{ t('ss_enterprise_benefit_onsite') }}</dt>
        <dd>
          <IconCheck class="y-icon" />
        </dd>
      </dl>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconCheck from '@/components/icons/IconCheck.vue';
import CloseIcon from '@/components/icons/IconClose.vue';
import { useModalSurvey } from '@/composables/domains/self-service/useModalSurvey';
import { useGtag } from '@/composables/shared/useGtag';
import { usePayment } from '@/composables/shared/usePayment';
import { usePlan } from '@/composables/shared/usePlan';
import { useSubscriptionStore } from '@/stores/subscription';
import { PlanPricing } from '@/types/components';

withDefaults(
  defineProps<{
    planPrices?: Record<string, PlanPricing>;
  }>(),
  {
    planPrices: () => ({}),
  }
);

const { t } = useI18n();
const router = useRouter();

const subscriptionStore = useSubscriptionStore();

const { setTypeSurveyUnsubscribe, openModalSurvey } = useModalSurvey();
const { formatCurrency, getPlanDisabledState, getPlanButtonText } = usePlan();
const {
  hasRegisteredCard,
  openCardRegisterPopup,
  openCardManagePopup,
  openSubscriptionPaymentPopup,
  openResubscriptionPopup,
} = usePayment();
const { trackEventFunnel } = useGtag();

const activeIndex = ref<number>(0);
const isLoading = ref<boolean>(false);

const tabs = ['Free', 'Starter', 'Pro', 'Enterprise'];

const selectTab = (index: number) => {
  activeIndex.value = index;
};

const isChangePlan = (plan): boolean => {
  if (['FREE', 'ENTERPRISE'].includes(plan)) {
    return false;
  }

  return plan !== subscriptionStore.currentPlan && subscriptionStore.currentPlanStatus !== 'PLANNED';
};

const handlePlanClick = async (plan) => {
  if (isLoading.value) return;

  try {
    isLoading.value = true;
    trackEventFunnel('click_plan_compare_button', {
      plan,
      billingCycle: subscriptionStore.currentPlanDetails?.billingCycle,
    });

    if (plan === 'ENTERPRISE') {
      goToContactPage();
      return;
    }

    if (plan === 'FREE' && ['STARTER', 'PRO'].includes(subscriptionStore.currentPlan)) {
      openUnSubscriptionPopup();
      return;
    }

    if (plan === subscriptionStore.currentPlan && subscriptionStore.currentPlanStatus === 'CANCEL') {
      openResubscriptionPopup(subscriptionStore.currentPlanDetails?.billingCycle);
      return;
    }

    if (!hasRegisteredCard()) {
      const registeredCardType = await openCardRegisterPopup();
      if (!registeredCardType) {
        trackEventFunnel('close_card_register_popup');
        return;
      }
    }

    const selectedCardType = await openCardManagePopup('PAYMENT', subscriptionStore.paymentType);
    if (!selectedCardType) {
      trackEventFunnel('close_card_select_popup');
      return;
    }

    openSubscriptionPaymentPopup(plan, subscriptionStore.currentPlanDetails?.billingCycle);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const goToContactPage = () => {
  trackEventFunnel('redirect_contact_page');
  router.push({ name: 'ss-contact' });
};

const openUnSubscriptionPopup = () => {
  trackEventFunnel('open_unsubscription_popup');

  setTypeSurveyUnsubscribe();
  openModalSurvey();
};
</script>

<style scoped lang="scss">
.mob-plan-compare-area {
  padding-top: 80px;
  .under-linetab-wrap {
    position: sticky;
    display: flex;
    gap: $size-s;
    button {
      font-size: $font-size-p;
      color: $color-gray-100;
      padding: 0 4px;
      &.on {
        font-weight: 600;
        color: $color-gray-900;
        border-bottom: 2px solid $color-gray-900;
      }
    }
  }
  .plan-ch-btn-wrap {
    display: none;
    justify-content: space-between;
    align-items: center;
    &.on {
      display: flex;
    }
    button {
      width: auto;
      padding: 0 1rem;
    }
    p {
      word-break: break-all;
    }
  }
  .mob-compare-tb {
    display: none;
    &.on {
      display: block;
    }
    dl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 0;
      border-bottom: 1px solid $color-gray-40;
      dt,
      dd {
        font-size: 15px;
        font-weight: 500;
      }
      dt {
        color: $color-gray-200;
      }
    }
  }

  .plan-sticky {
    display: flex;
    position: sticky;
    top: 65px;
    background: #fff;
    padding: 2rem 0;
    gap: 1rem;
    li {
      flex: 1 1 0%;
      .sticky-tit {
        min-height: 100px;
        strong {
          display: block;
          text-align: left;
          padding-bottom: $size-s;
        }
        span {
          font-size: $font-size-psmall;
        }
      }
    }
  }

  @include respond-to(mobile-landscape) {
    .plan-ch-btn-wrap {
      flex-direction: column;
      align-items: flex-start;
      gap: $size-s;
      button {
        width: 100%;
      }
    }
  }
}

.n-icon {
  color: $color-gray-200;
}
.y-icon {
  color: $color-navy-100;
  width: 20px;
  height: 20px;
  object-fit: contain;
  :deep(path) {
    stroke-width: 1px !important;
  }
}
</style>
